import React, { ReactNode } from 'react';

import { JobFormManager } from 'jobs/job-form/job-form.manager';

const CreateJobContext = React.createContext<JobFormManager | null>(null);

export const CopyJobProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState<JobFormManager>(() => new JobFormManager('COPY'));

   return <CreateJobContext.Provider value={store}>{children}</CreateJobContext.Provider>;
};

export const useCopyJob = () => {
   const ctx = React.useContext(CreateJobContext);
   if (!ctx) {
      throw new Error('useCopyJob must be used inside CopyJobProvider');
   }
   return ctx;
};
